import { useState, type FormEvent, type ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthProvider';

export function ChangePasswordPage(): ReactNode {
  const auth = useAuth();
  const navigate = useNavigate();
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmation, setConfirmation] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  async function submit(event: FormEvent): Promise<void> {
    event.preventDefault();
    if (newPassword !== confirmation) {
      setError('Новые пароли не совпадают');
      return;
    }
    setBusy(true);
    setError('');
    try {
      await auth.changePassword(currentPassword, newPassword);
      navigate('/pipeline', { replace: true });
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : 'Не удалось сменить пароль');
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className="workspace-page change-password-page">
      <header className="workspace-header"><div><h1>Смена пароля</h1><p>Замените временный пароль на свой.</p></div></header>
      <form className="settings-form password-form" onSubmit={(event) => void submit(event)}>
        <label>Текущий пароль<input type="password" autoComplete="current-password" value={currentPassword} onChange={(event) => setCurrentPassword(event.target.value)} required /></label>
        <label>Новый пароль<input type="password" autoComplete="new-password" minLength={16} value={newPassword} onChange={(event) => setNewPassword(event.target.value)} required /></label>
        <label>Повторите новый пароль<input type="password" autoComplete="new-password" minLength={16} value={confirmation} onChange={(event) => setConfirmation(event.target.value)} required /></label>
        {error ? <p className="inline-error" role="alert">{error}</p> : null}
        <div className="drawer-actions"><button className="button button-secondary" type="button" onClick={() => navigate(-1)}>Отмена</button><button className="button button-primary" disabled={busy}>{busy ? 'Сохраняем…' : 'Сменить пароль'}</button></div>
      </form>
    </main>
  );
}
